import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { WebAuth } from '@555platform/author.js';
import Image from '../i/icons_d.png';
import LandingPatternImg from '../i/landing-pattern.png';
// import LaptopImg from '../i/laptop.png';
import Icon from '../i/Comcast_555_Logo_SigComm_final_3.svg';

const styles = {

  // /* .intro-section
  IntroSectionElement: {
    position: 'relative',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',

  },
  // .intro-section-inner
  introSectionInnerClass: {
    position: 'relative',
    zIndex: '10',
  },
  // .intro-section-triangle
  introSectionTriangleClass: {
    height: '200px',
    position: 'absolute',
    top: '0',
    width: '100%',
    zIndex: '-1',
    // clipPath: 'polygon(0% 80%, 0% 0%, 100% 0%, 100% 25%)',
    // background: 'linear-gradient(160deg, #334956, #2D404C)',
    background: '#334956',
  },
  // .intro-section .intro-header
  introSectionIntroHeaderClass: {
    position: 'relative',
    zIndex: '20',
  },
  // .intro-header .header-right
  introHeaderHeaderRightClass: {
    margin: '20px 38px 0 0',
  },
  //* /.intro-section-inner .intro-body
  IntroSectionInnerIntroBodyElement: {
    display: 'table',
    margin: '43px auto 0 auto',
  },
  // .intro-section-inner .intro-body img
  introSectionInnerIntroBodyimgClass: {
    width: '74px',
    height: '68px',
    display: 'block',
    margin: 'auto',
  },
  // .intro-section-inner .intro-body .logo-txt
  introSectionInnerIntroBodyLogoTxtClass: {
    fontSize: '28px',
    color: '#fff',
    fontWeight: '600',
    textAlign: 'center',
    display: 'block',
    margin: '20px 0 30px 0',
  },
  // .download-learnmore-btns
  downloadLearnmoreBtnsClass: {
    display: 'table',
    margin: 'auto',
  },
  // .download-learnmore-btns a
  downloadLearnmoreBtnsaClass: {
    fontWeight: '500',
    float: 'left',
    display: 'block',
    backgroundColor: '#2fb3fa',
    color: '#fff',
    textAlign: 'center',
    margin: '0 33px 0 0',
    width: '135px',
    lineHeight: '40px',
    borderRadius: '47px',
    fontSize: '14px',
  },
  appLogo: {
    position: 'absolute',
    top: -40,
    left: -40,
    width: 300,
    height: 300,
  },
  introSectionInnerIntroBodypClass: {
    fontSize: '15px',
    color: '#fff',
    textAlign: 'center',
    margin: '0 0 46px 0',
    lineHeight: 'normal',
  },
  // .intro-signin-btn
  introSigninBtnClass: {
    width: '135px',
    lineHeight: '37px',
    borderRadius: '47px',
    fontWeight: 500,
    textDecoration: 'none',
    margin: '0 33px 0 0',
    fontSize: '14px',
  },
  whiteBorderBtn: {
    display: 'block',
    color: '#fff',
    border: '1px solid #fff',
    textAlign: 'center',
    '&:hover': {
      opacity: '0.7',
      color: '#fff',
    },
  },
  // /* laptop-section */  .laptop-section
  laptopSectionLaptopSectionElement: {
    display: 'table',
    margin: '80px auto 78px auto',
    position: 'relative',
  },
  // .laptop-section img
  laptopSectionimgClass: {
    width: '889px',
    height: '503px',
    display: 'block',
    margin: 'auto',
  },
  // .laptop-section .laptop-rounds
  LaptopRoundsClass: {
    display: 'block',
    width: '90px',
    height: '90px',
    backgroundColor: '#fff',
    WebkitBoxShadow: '0px 0px 73px 10px rgba(0,0,0,0.1)',
    MozBoxShadow: '0px 0px 73px 10px rgba(0,0,0,0.1)',
    boxShadow: '0px 0px 73px 10px rgba(0,0,0,0.1)',
    borderRadius: '100%',
    position: 'absolute',
  },
  // blue-btn
  blueBtnElement: {
    display: 'block',
    backgroundColor: '#2fb3fa',
    color: '#fff',
    textAlign: 'center',
    '&:hover': {
      opacity: '0.7',
      color: '#fff',
    },
  },
  // .api-circle
  apiCircleClass: {
    right: '269px',
    top: '-21px',
  },
  apiCircleImg: {
    width: '60px',
    height: '60px',
    backgroundPosition: '0 0 !important',
    margin: '16px 0 0 16px',
  },
  // .video-circle
  videoCircleClass: {
    left: '50px',
    top: '108px',
  },
  videoCircleImg: {
    width: '44px',
    height: '34px',
    backgroundPosition: '-62px 0 !important',
    margin: '28px 0 0 23px',
  },
  // .msg-circle
  msgCircleClass: {
    right: '30px',
    top: '121px',
  },
  msgCircleImg: {
    width: '40px',
    height: '35px',
    backgroundPosition: '-116px 0 !important',
    margin: '27px 0 0 25px',
  },
  // .mic-circle
  micCircleClass: {
    left: '15px',
    top: '330px',
  },
  micCircleImg: {
    width: '36px',
    height: '48px',
    backgroundPosition: '-174px 0 !important',
    margin: '21px 0 0 27px',
  },
  // .mouse-circle
  mouseCircleClass: {
    right: '30px',
    top: '356px',
  },
  mouseCircleImg: {
    width: '50px',
    height: '60px',
    backgroundPosition: '-220px 0 !important',
    margin: '15px 0 0 20px',
  },
  iconsDElement: {
    display: 'block',
    background: `url(${Image}) no-repeat`,
    backgroundSize: '750px 340px',
  },
  tabMobshow: {
    display: 'none',
  },
  // .landing-headings
  landingHeadingsClass: {
    fontSize: '35px',
    fontWeight: '500',
    color: '#282828',
    textAlign: 'center',
  },
  // .landing-desc-txt
  landingDescTxtClass: {
    lineHeight: '27px',
    fontSize: '13px',
    color: '#282828',
    textAlign: 'center',
    width: '758px',
    margin: 'auto',
    padding: '25px 0 53px 0',
  },
  // .landing-aboutus-section img
  landingAboutusSectionimgClass: {
    width: '1110px',
    height: '528px',
    margin: 'auto',
    display: 'block',
    border: '7px solid #fff',
    borderRadius: '40px',
  },
  left: {
    float: 'left',
  },
  clearfix: {
    clear: 'both',
  },
  boxs: {
    width: '1112px',
    margin: 'auto',
  },
  headerNavItems: {
    display: 'block',
    fontSize: '10px',
    color: '#fff',
    padding: '0 11px',
    lineHeight: '30px',
    textDecoration: 'none',
  },
  active: {
    borderBottom: '1px solid rgba(255, 255, 255, 0.52)',
  },
  headerRight: {
    margin: '24px 38px 0 0',
  },
  right: {
    float: 'right',
  },
  headerListItem: {
    float: 'left',
    margin: '0 10px 0 0',
    listStyle: 'none',
  },
  signInBtn: {
    fontSize: '12px',
    display: 'block',
    width: '90px',
    lineHeight: '30px',
    borderRadius: '40px',
    backgroundColor: '#fff',
    textAlign: 'center',
    textDecoration: 'none',
    color: '#2b9cd8',
    fontWeight: '600',
    margin: '0 0 0 25px',
    cursor: 'pointer',
  },
  introList: {
    margin: 0,
  },


};

const laptopRoundImages = [
  {
    circleClass: 'apiCircleClass',
    imgClass: 'apiCircleImg',
  },
  {
    circleClass: 'videoCircleClass',
    imgClass: 'videoCircleImg',
  },
  {
    circleClass: 'msgCircleClass',
    imgClass: 'msgCircleImg',
  },
  {
    circleClass: 'micCircleClass',
    imgClass: 'micCircleImg',
  },
  {
    circleClass: 'mouseCircleClass',
    imgClass: 'mouseCircleImg',
  },
];
class IntroSection extends React.Component {
  handleLogin = () => {
    const {
      domain, clientID, redirectURI, authServer,
    } = this.props;
    const webAuth = WebAuth({
      domain,
      clientID,
      responseType: 'code',
      redirectURI,
      scope: 'everything',
      authServer,
    });
    webAuth.login({ state: 'xyz' });
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.IntroSectionElement}>
        <span className={classNames(classes.iconsDElement, classes.tabMobShow)} />
        <div className={classes.introSectionInnerClass}>
          {/* <img src={LandingPatternImg} alt="" className={classes.introSectionTriangleClass} /> */}
          <span className={classes.introSectionTriangleClass} />
          <div className={classes.introSectionIntroHeaderClass}>
            <span>
              <img className={classes.appLogo} src={Icon} alt="logo" />
            </span>
            <div className={classNames(classes.headerRight, classes.right)}>
              <ul className={classNames(classes.left, classes.introList)}>
                {/* <li className={classes.headerListItem}>
                  <span className={classNames(classes.headerNavItems, classes.active)}>Home</span>
                 </li> */}
                <li className={classes.headerListItem}>
                  <a href="https://www.555.comcast.com" className={classes.headerNavItems}>Documentation</a>
                </li>
                {/* <li className={classes.headerListItem}>
                  <a href={`${config.baseUrl555}/blog`} className={classes.headerNavItems}>Blog</a>
                </li> */}
              </ul>
              <div className={classes.left}>
                <span role="presentation" id="sign_in" onClick={this.handleLogin} className={classNames(classes.signInBtn, classes.left)}>Sign in</span>
              </div>
            </div>
            <div className={classes.clearfix} />
            <div className={classes.boxs}>
              <div className={classes.IntroSectionInnerIntroBodyElement}>
                <span className={classes.introSectionInnerIntroBodyLogoTxtClass}>
                  Developer Portal
                </span>
                <p className={classes.introSectionInnerIntroBodypClass}>
                  Secure WebRTC, Messaging and Authentication
                </p>
                <div className={classes.downloadLearnmoreBtnsClass}>
                  {/* <span className={
                    classNames(classes.blueBtnElement, classes.introSigninBtnClass, classes.left)
                  }
                  >
                    Download
                  </span>
                  <span className={
                    classNames(classes.introSigninBtnClass, classes.whiteBorderBtn, classes.left)
                  }
                  >
                    Learn more
                  </span> */}
                  <div className={classes.clearfix} />
                </div>
              </div>
              <div className={classes.laptopSectionLaptopSectionElement}>
                {/* <img src={LaptopImg} alt="" className={classes.laptopSectionimgClass} />
                {
                  laptopRoundImages.map(item => (
                    <div
                      className={classNames(classes.LaptopRoundsClass, classes[item.circleClass])}
                    >
                      <span
                        className={
                          classNames(classes[item.imgClass], classes.iconsDElement, classes.left)
                        }
                      />
                    </div>
                  ))
                } */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(IntroSection);

IntroSection.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  domain: PropTypes.string.isRequired,
  clientID: PropTypes.string.isRequired,
  redirectURI: PropTypes.string.isRequired,
  authServer: PropTypes.string.isRequired,
};

IntroSection.defaultProps = {
  classes: {},
};
